<template>
    <div >
        <div class="panel panel-success">

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU CONCENTRADOR
            </div>
            <div class="panel-body" v-if="user.level < 5 && !user.permissoes.cacontrol" >
                <p>
                    <a :href="'#/concentrador'" class="btn btn-info btn-block">NOVO CONCENTRADOR</a>
                </p>
            </div>

        </div>

        <div class="panel panel-danger" v-if="concentrador && concentrador._id" >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-terminal" aria-hidden="true"></i> COMANDOS
            </div>
            <!-- List group -->
            <ul class="list-group">
                <li class="list-group-item" v-if="user.permissoes.comandos && user.level <= 5">
                    <a :href="'#/concentrador/comandos/' + concentrador._id" >COMANDOS</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        concentrador: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
